module.exports = `${require.publicPath}download-btn1.e1eb2a95.png`;